import styled from 'styled-components';
import { ReactComponent as RawCloudSVG } from '../../../../assets/icons/cloud_icon.svg';

export const IconCloud = styled(RawCloudSVG)``;
